import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { Canvas } from '../Canvas/canvas.js';

const Cta = props => {
  const onClick = event => {
    if (typeof props.onClick === 'function') {
      props.onClick(event);
    }
  };
  const bg = props.type == 'button' || props.type == 'submit' ? jsx(Canvas, {}) : '';
  const icon = props.icon || (props.type == 'text' ? jsx(IconLlmArrowRight, {}) : '');
  const classNames = getClassNames('llm__cta', `llm__cta--${props.type}`, props.className);
  return props.url ? jsxs("a", {
    className: classNames,
    href: props.url,
    target: props.target,
    children: [bg, jsx("span", {
      children: props.label
    }), icon]
  }) : jsxs("button", {
    className: classNames,
    onClick: onClick,
    type: props.type == 'button' || props.type == 'submit' ? props.type : undefined,
    children: [bg, jsx("span", {
      children: props.label
    }), icon]
  });
};

export { Cta };
//# sourceMappingURL=cta.js.map
